<template>
  <div class="account-section">
    <b-row class="m__b--20">
      <b-col cols="8"> </b-col>
      <b-col cols="4">
        <div class="float-to-right button-create-account">
          <b-button @click="$router.replace('/home/account/create')"
            >Add Account
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!-- <b-row class="m__b--21">
      <b-col cols="4">
        <vue-treeselect
          v-model="value"
          :options="options_filter"
          placeholder="Filters"
        />
      </b-col>
      <b-col cols="8">
        <div class="float-to-right form-search-account">
          <b-form-input placeholder="Search"></b-form-input>
        </div>
      </b-col>
    </b-row> -->

    <b-card>
      <div
        class="table-head-custom"
        :class="{ loading: is_loading }"
        v-if="!loading_table"
      >
        <!-- <v-server-table
          ref="serverTable"
          :columns="columns"
          :options="options"
          @loading="loading"
          @loaded="loaded"
        >
          <div slot="view" slot-scope="props">
            <div
              class="float-to-left cursor-pointer view"
              @click="openModal(props, 'view')"
            >
              <i class="fas fa-eye"></i>
            </div>
          </div>

          <div slot="delete" slot-scope="props">
            <div
              class="float-to-left cursor-pointer delete"
              @click="openModal(props, 'delete')"
            >
              <i class="fas fa-trash"></i>
            </div>
          </div>

          <div slot="edit" slot-scope="props">
            <div
              class="float-to-left cursor-pointer edit"
              @click="openModal(props, 'edit')"
            >
              <i class="fas fa-pen"></i>
            </div>
          </div>
        </v-server-table> -->
        <v-client-table
          ref="serverTable"
          :data="accountState.list"
          :columns="columns"
          :options="options"
          @loading="loading"
          @loaded="loaded"
        >
          <div slot="view" slot-scope="props">
            <div
              class="float-to-left cursor-pointer view"
              @click="openModal(props, 'view')"
            >
              <i class="fas fa-eye"></i>
            </div>
          </div>

          <div slot="delete" slot-scope="props">
            <div
              class="float-to-left cursor-pointer delete"
              @click="openModal(props, 'delete')"
            >
              <i class="fas fa-trash"></i>
            </div>
          </div>

          <div slot="edit" slot-scope="props">
            <div
              class="float-to-left cursor-pointer edit"
              @click="openModal(props, 'edit')"
            >
              <i class="fas fa-pen"></i>
            </div>
          </div>
        </v-client-table>
      </div>
      <TableLoading v-else />
    </b-card>
  </div>
</template>

<script>
import Store from '@/stores';
import { mapState } from 'vuex';
import TableLoading from '@/components/Loading/TableLoading';

export default {
  name: 'Account',
  components: {
    TableLoading
  },
  data() {
    return {
      value: null,
      loading_table: false,
      options_filter: [
        {
          id: 'name',
          label: 'Name'
        },
        {
          id: 'role',
          label: 'Role'
        },
        {
          id: 'email',
          label: 'Email'
        }
      ],
      is_loading: false,
      columns: ['name', 'role', 'email', 'delete', 'edit'],
      options: {
        filterByColumn: true,
        perPageValues: [5, 10, 25, 50, 100],
        filterable: ['name', 'role', 'email'],
        perPage: 5,
        sortable: [],
        requestAdapter: function(data) {
          return data;
        },
        requestFunction: async function(data) {
          try {
            const req = {
              sort: data.byColumn,
              per_page: data.limit,
              page: data.page,
              search: ''
            };
            // const req = {
            //   sort: '',
            //   per_page: 0,
            //   page: 0,
            //   search: ''
            // };
            const res = await Store.dispatch('StoreAccount/listAccount', req);
            return res;
          } catch (err) {
            return err;
          }
        },
        responseAdapter: function(resp) {
          return { data: resp.data.data, count: resp.data.total };
        },
        resizableColumns: true,
        pagination: { chunk: 5 }
        // see the options API
      }
    };
  },
  created() {
    const req = {
      sort: '',
      per_page: 0,
      page: 0,
      search: ''
    };
    Store.dispatch('StoreAccount/listAccount', req);
    if (this.accountState.list.length === 0) {
      this.loading_table = true;
    }
  },
  computed: {
    ...mapState('StoreAccount', ['accountState'])
  },
  watch: {
    'accountState.created'() {
      this.refreshTable();
    },

    'accountState.deleted'() {
      this.refreshTable();
    },

    'accountState.list'() {
      this.loading_table = false;
    },

    'accountState.edited'() {
      this.refreshTable();
    },

    'accountState.passEdited'() {
      this.refreshTable();
    }
  },
  methods: {
    async refreshTable() {
      const req = {
        sort: '',
        per_page: 0,
        page: 0,
        search: ''
      };
      this.loading();
      try {
        await Store.dispatch('StoreAccount/listAccount', req);
        this.loaded();
      } catch (err) {
        this.loaded();
        throw err;
      }

      // this.$refs.serverTable.getData();
    },
    loading() {
      this.is_loading = true;
    },
    loaded() {
      this.is_loading = false;
    },
    openModal(data, mode) {
      if (mode === 'delete') {
        this.$swal({
          icon: 'warning',
          title: 'Delete',
          text: 'Are you sure want to delete it?',
          showCancelButton: true,
          confirmButtonColor: '#ff6961',
          focusConfirm: false,
          confirmButtonText: 'Yes, delete it!'
        }).then(result => {
          if (result.value) {
            console.log(data);
            const req = {
              id: data.row.id
            };
            this.$store.dispatch('StoreAccount/deleteAccount', req);
          }
        });
      } else {
        this.$router.replace('/home/account/edit/' + data.row.id);
      }
    }
  }
};
</script>

<style lang="scss">
.account-section {
  .VuePagination__count {
    padding-left: 0px;
    text-align: left !important;
  }
  .VueTables__limit-field {
    label {
      justify-content: left;
    }
    select {
      width: 100px;
    }
  }
  .button-create-account {
    button {
      background: #fb9c0a;
      box-shadow: 0px 4px 20px rgba(251, 156, 10, 0.3);
      border-radius: 3px;
      padding: 10px 25px;
      border: unset;
    }
  }
  .vue-treeselect__control {
    width: 100%;
    height: 45px;
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    border: unset;
    .vue-treeselect__placeholder {
      padding-top: 5px;
      padding-left: 15px;
    }
    input {
      padding-left: 10px;
    }
    .vue-treeselect__single-value {
      padding-top: 5px;
      padding-left: 15px;
    }
  }
  .form-search-account {
    input {
      width: 100%;
      height: 45px;
      background: #ffffff;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
      border-radius: 3px;
      border: unset;
      padding-left: 15px;
      &::placeholder {
        color: #bdbdbd;
      }
    }
  }
  .card {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }
  #VueTables_th--view,
  #VueTables_th--delete,
  #VueTables_th--edit {
    width: 50px;
  }
  .view {
    width: 30px;
    height: 30px;
    color: #fff;
    background: #0095e9;
    border-radius: 2px;
    padding: 6px;
  }
  .edit {
    width: 30px;
    height: 30px;
    color: #fff;
    background: #fb9c0a;
    border-radius: 2px;
    padding: 6px;
  }
  .delete {
    width: 30px;
    height: 30px;
    color: #fff;
    background: #ff6961;
    border-radius: 2px;
    padding: 8px;
  }
}

.table-head-custom {
  &.loading {
    opacity: 0.4;
  }
  th,
  td {
    color: #1d2d4e;
  }
  .page-item.active .page-link {
    background-color: #0095e9;
    border-color: #0095e9;
  }
  .page-link {
    color: #0095e9;
  }
  .table-bordered thead th,
  .table-bordered thead td {
    border: unset;
    border-bottom: 2px solid #dee2e6;
    border-bottom-width: 2px;
  }
  .table-bordered th,
  .table-bordered td {
    border: unset;
    border-bottom: 1px solid #dee2e6;
  }
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: unset;
  }
}

.card {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  .card-body {
    border: unset;
  }
}
</style>
